import React from 'react';
import ThankYouComponent from './ThankYouComponent';
import { TEXT } from 'locales/translations';

export const ThankYouGift = () => {
  return <ThankYouComponent body={TEXT.thankYou.copyGiftPurchase} />;
};
